const appSettings = {
    // backendBaseUrl: "https://localhost:7200"
    backendBaseUrl: "https://api.logicayachts.com"
}

export default appSettings;